var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:{'is-clickable': _vm.userCanEdit},on:{"click":_vm.toggleCheckBox}},[_c('b-loading',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),(_vm.value === 1)?_c('check-square-icon',{attrs:{"size":_vm.iconSize}}):_c('square-icon',{attrs:{"size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }